import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ filters, onFilterChange }) => {
  const actionTypeOptions = [
    { value: 'all', label: 'All Actions' },
    { value: 'created', label: 'Created' },
    { value: 'updated', label: 'Updated' },
    { value: 'deleted', label: 'Deleted' }
  ];

  const entityTypeOptions = [
    { value: 'all', label: 'All Entities' },
    { value: 'employees', label: 'Employees' },
    { value: 'violation_records', label: 'Violation Records' },
    { value: 'roles', label: 'Roles' },
    { value: 'departments', label: 'Departments' },
    { value: 'job_fields', label: 'Job Fields' },
    { value: 'violation_categories', label: 'Violation Categories' },
    { value: 'point_thresholds', label: 'Point Thresholds' },
    { value: 'compliance_rules', label: 'Compliance Rules' },
    { value: 'system', label: 'System' }
  ];

  const handleSearchChange = (e) => {
    onFilterChange({ searchTerm: e?.target?.value });
  };

  const handleActionTypeChange = (value) => {
    onFilterChange({ actionType: value });
  };

  const handleEntityTypeChange = (value) => {
    onFilterChange({ entityType: value });
  };

  const handleStartDateChange = (e) => {
    onFilterChange({ startDate: e?.target?.value });
  };

  const handleEndDateChange = (e) => {
    onFilterChange({ endDate: e?.target?.value });
  };

  const handleClearFilters = () => {
    onFilterChange({
      actionType: 'all',
      entityType: 'all',
      startDate: '',
      endDate: '',
      searchTerm: ''
    });
  };

  const hasActiveFilters = 
    filters?.actionType !== 'all' ||
    filters?.entityType !== 'all' ||
    filters?.startDate ||
    filters?.endDate ||
    filters?.searchTerm;

  return (
    <div className="bg-card rounded-lg elevation-sm p-4 md:p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg font-semibold text-foreground">
          Filter Audit Logs
        </h3>
        {hasActiveFilters && (
          <button
            onClick={handleClearFilters}
            className="font-body text-sm text-primary hover:text-primary/80 transition-smooth"
          >
            Clear Filters
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search by user, entity, or change summary..."
            value={filters?.searchTerm}
            onChange={handleSearchChange}
            className="w-full"
          />
        </div>

        {/* Action Type */}
        <div>
          <Select
            options={actionTypeOptions}
            value={filters?.actionType}
            onChange={handleActionTypeChange}
            placeholder="Action Type"
          />
        </div>

        {/* Entity Type */}
        <div>
          <Select
            options={entityTypeOptions}
            value={filters?.entityType}
            onChange={handleEntityTypeChange}
            placeholder="Entity Type"
          />
        </div>

        {/* Date Range - Start */}
        <div>
          <Input
            type="date"
            value={filters?.startDate}
            onChange={handleStartDateChange}
            placeholder="Start Date"
            className="w-full"
          />
        </div>
      </div>

      {/* Second Row for End Date */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
        <div className="lg:col-start-5">
          <Input
            type="date"
            value={filters?.endDate}
            onChange={handleEndDateChange}
            placeholder="End Date"
            className="w-full"
          />
        </div>
      </div>

      {/* Active Filters Summary */}
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-body text-sm text-muted-foreground">Active filters:</span>
            {filters?.actionType !== 'all' && (
              <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Action: {actionTypeOptions?.find(opt => opt?.value === filters?.actionType)?.label}
              </span>
            )}
            {filters?.entityType !== 'all' && (
              <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Entity: {entityTypeOptions?.find(opt => opt?.value === filters?.entityType)?.label}
              </span>
            )}
            {filters?.startDate && (
              <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                From: {new Date(filters?.startDate)?.toLocaleDateString()}
              </span>
            )}
            {filters?.endDate && (
              <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                To: {new Date(filters?.endDate)?.toLocaleDateString()}
              </span>
            )}
            {filters?.searchTerm && (
              <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Search: "{filters?.searchTerm}"
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;